import { ReactNode } from 'react';
import clsx from 'clsx';
import styles from './Box.module.css';
import { AdjustProps } from '../../Adjust/Adjust';
import adjustStyles from '../../Adjust/Adjust.module.css';

export enum BoxBackGround {
    NORMAL = '',
    FILL = 'var-02',
    ALERT = 'bg-alert'
}

export interface BoxProps {
    heading?: ReactNode;
    children: ReactNode;
    background?: BoxBackGround;
    id?: string;
    adjust?: Pick<AdjustProps, 'mb'>;
}

export const Box = (props: BoxProps) => {
    const {heading, children, background = BoxBackGround.NORMAL, id, adjust} = props;
    const componentStyles = clsx({
        [styles['mod-box']]: true,
        [styles[background]]: !!background,
        [adjustStyles[`mb-` + adjust?.mb]]: !!adjust,
    });
    return (
        <section className={componentStyles} id={id}>
            <div className={styles['inner']}>
                { heading && <div className={styles['hdg']}>{heading}</div> }
                {children}
            </div>
        </section>
    );
};

export interface TitleBoxProps {
    title?: string;
    heading?: string;
    children: ReactNode;
    id?: string;
}

export const TitleBox = (props: TitleBoxProps) => {
    const {title, heading, children, id} = props;
    const componentStyles = clsx(styles['mod-box-02']);
    return (
        <section className={componentStyles} id={id}>
            {title && (
                <div className={styles['title']}>
                    <h3 className={styles['hdg']}>{title}</h3>
                </div>
            )}
            <section className={styles['inner']}>
                {heading && <h3 className={styles['hdg']}>{heading}</h3>}
                {children}
            </section>
        </section>
    );
};
